 <div class="app-security-question">
   <div class="card-title">
     <span>{{'SETUP_SECURITY_QUESTIONS' | dictionary}}</span>
   </div>


   <div class="body-wrapper">
     <div>
       <h5 class="text-center subtitle-wrapper">
         {{'ACCESS_ACCOUNT_BY_ANSWERING_QUESTIONS' |dictionary}}
       </h5>
       <h6 class="text-center small-note-text">
         {{'CHOOSE_QUESTIONS_AND_ANSWERS' | dictionary}}
       </h6>
     </div>

     <!-- Setup new security questions  -->
     <table class="table table-hover sec-text-container" style="margin-bottom: 0;">
       <tbody>
       <tr>
         <td class="label">
           {{'SECURITY_QUESTION' | dictionary}}
         </td>
         <td>
           <select #dropDownStatic class="security-question-dropdown"
                   [(ngModel)]="securityQuestionAnswer.SecQuestionCode1">
             <option value=""></option>
             <option *ngFor="let data of questionList" [ngValue]="data.SecQuestionCode">
               {{data.SecQuestionText}}
             </option>
           </select>
         </td>
       </tr>
       <tr>
         <td class="label">
           {{'ANSWER' | dictionary}}
         </td>
         <td>
           <input type="text" style="width: 100%;" [(ngModel)]="securityQuestionAnswer.SecAnswerText1"/>
         </td>
       </tr>

       <tr>
         <td class="label">
           {{'SECURITY_QUESTION' | dictionary}}
         </td>
         <td>
           <select #dropDownStatic class="security-question-dropdown"
                   [(ngModel)]="securityQuestionAnswer.SecQuestionCode2">
             <option value=""></option>
             <option *ngFor="let data of questionList" [ngValue]="data.SecQuestionCode">
               {{data.SecQuestionText}}
             </option>
           </select>
         </td>
       </tr>
       <tr>
         <td class="label">
           {{'ANSWER' | dictionary}}
         </td>
         <td>
           <input type="text" style="width: 100%;" [(ngModel)]="securityQuestionAnswer.SecAnswerText2"/>
         </td>
       </tr>

       <tr>
         <td class="label">
           {{'SECURITY_QUESTION' | dictionary}}
         </td>
         <td>
           <select #dropDownStatic class="security-question-dropdown"
                   [(ngModel)]="securityQuestionAnswer.SecQuestionCode3">
             <option value=""></option>
             <option *ngFor="let data of questionList" [ngValue]="data.SecQuestionCode">
               {{data.SecQuestionText}}
             </option>
           </select>
         </td>
       </tr>
       <tr>
         <td class="label">
           {{'ANSWER' | dictionary}}
         </td>
         <td>
           <input type="text" style="width: 100%;" [(ngModel)]="securityQuestionAnswer.SecAnswerText3"/>
         </td>
       </tr>

       </tbody>
     </table>

     <div class="col-lg-12" style="margin-top: 10px;text-align: center;">
       <button class="sec-button button-1"
               (click)="afterAllProcessDone()">{{'ASK_LATER' | dictionary}}
       </button>
       <button class="ml-15 sec-button button-1" (click)="submitTheAnswer()">{{'SUBMIT' | dictionary}}</button>
     </div>

   </div>
 </div>

 <app-pop-up-dialog [Message]="alertMessage" [Display]="display" (DisplayBack)="display = false">
 </app-pop-up-dialog>




